/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
// Компоненты пользовательского интерфейса
import '../../styles/AdjacencyEdit.css';
import Selector from '../CustomElements/Selector';
import CustomButtonDelete from '../CustomElements/CustomButtonDelete';
import CustomButton from '../CustomElements/CustomButton';
import Preloader from '../CustomElements/Preloader';
import { useLoader } from './Common';
// Действия Redux
import { initOptionsRailChainsFromServer } from '../../redux/actions/options.action';
import { saveAdjacencyFromServer } from '../../redux/actions/infocards.action';
import { load, remove } from '../../redux/actions/loader.action';

function AdjacencyEdit({ closeModal, t }) {
  const dispatch = useDispatch();

  //получаем id текущей смежности
  const { adjacency } = useParams();

  // хук для отслеживания процесса запросов
  const { isLoading, isSuccess } = useLoader();

  // получаем опции из стейта
  const selectOptions = useSelector((state) => state?.options);

  // получаем все смежности из стейта
  const adjacencys = useSelector((s) => s.infocards.adjacency);

  // Функция для поиска объекта по railСhain
  const findObjectByRailChain = (railChain) => {
    return adjacencys?.find((item) => item.railChain === Number(railChain));
  };

  //стейт для текущей смежность
  const [currentAdjacency, setCurrentAdjacency] = useState();

  // заменяем нулы на объекты, для отображения в таблице
  const replaceNullsInAdjacency = (currentAdjacency) => {
    if (!currentAdjacency?.adjacency?.length) {
      return [{ station: currentAdjacency?.station, railChain: '' }];
    }
    return currentAdjacency.adjacency;
  };

  // состояние для  сета из railСhain в adjacency
  const [excludedRailChains, setExcludedRailChains] = useState(new Set());

  //добавление смежности
  const handleAdd = () => {
    setCurrentAdjacency((prev) => ({
      ...prev,
      adjacency: [
        ...prev.adjacency,
        {
          railChain: '',
          name: '',
          station: prev?.station,
          stationName: prev?.stationName,
        },
      ],
    }));
  };

  // Удаление смежности по индексу
  const removeAdjacencyByIndex = (index) => {
    setCurrentAdjacency((prevState) => {
      const updatedAdjacency = [...prevState.adjacency]; // Создаем копию массива
      updatedAdjacency.splice(index, 1); // Удаляем элемент по индексу

      return {
        ...prevState,
        adjacency: updatedAdjacency,
      };
    });
  };

  // Проверяем, были ли изменения в смежностях
  const isAdjacencyChanged = useMemo(() => {
    const oldAdjacency = findObjectByRailChain(adjacency);
    // Сравниваем текущее значение с исходным
    return JSON.stringify(oldAdjacency?.adjacency) !== JSON.stringify(currentAdjacency?.adjacency);
  }, [currentAdjacency, adjacency]);

  // Проверяем, что все rail_chain в adjacency заполнены
  const areAllRailChainsFilled = useMemo(() => {
    return currentAdjacency?.adjacency?.every((adj) => Boolean(adj.railChain));
  }, [currentAdjacency]);

  // Если изменений нет, нет смежностей или не все railChain заполнены, блокируем кнопку сохранить
  const isDisabled = !currentAdjacency?.adjacency?.length || !isAdjacencyChanged || !areAllRailChainsFilled;

  // сохранение изменений для смежности
  const handleSave = () => {
    // Переводим в состояние загрузки
    dispatch(load());
    const payload = {
      adjacency: Array.from(excludedRailChains),
    };
    dispatch(
      saveAdjacencyFromServer({
        payload,
        stationId: currentAdjacency?.station,
        railChainId: currentAdjacency.railChain,
      })
    );
  };

  // Функция для получения всех опций и отфильтрованных опций
  const getOptionsAndFilteredOptionsForRC = (selectOptions, originalStation, excludedRailChains) => {
    const options = selectOptions?.railChainsPerStation?.[originalStation] || [];
    const filteredOptionsForRC = options.filter((option) => !excludedRailChains.has(option.value));
    const extendedOptionsForRC = filteredOptionsForRC.map((rc) => ({
      value: rc?.value,
      label: `${rc.label} (${rc.value})`,
    }));

    return extendedOptionsForRC;
  };

  // Обработчик изменения рельсовой цепи
  const handleRailChainChange = (selectedOption, index, previousValue) => {
    const newRailChain = selectedOption?.value || '';
    const newName = selectedOption?.label || '';

    setExcludedRailChains((prev) => {
      const newSet = new Set(prev);
      if (previousValue) newSet.delete(previousValue); // Удаляем предыдущее значение
      if (newRailChain) newSet.add(newRailChain); // Добавляем новое значение
      return newSet;
    });

    setCurrentAdjacency((prev) => {
      const updatedAdjacency = [...prev.adjacency];
      updatedAdjacency[index] = {
        ...updatedAdjacency[index],
        railChain: newRailChain,
        name: newName,
      };
      return { ...prev, adjacency: updatedAdjacency };
    });
  };

  // Обработчик изменения станции
  const handleStationChange = (selectedOption, index) => {
    const newStation = selectedOption?.value || '';
    const newStationName = selectedOption?.label || '';

    setCurrentAdjacency((prev) => {
      const updatedAdjacency = [...prev.adjacency]; // Создаем копию массива
      updatedAdjacency[index] = {
        railChain: '',
        name: '',
        station: newStation,
        stationName: newStationName,
      };

      return { ...prev, adjacency: updatedAdjacency };
    });
  };

  //сохраняем в стейт текущую смежность
  useEffect(() => {
    const foundAdjacency = findObjectByRailChain(adjacency);
    const processedAdjacency = {
      ...foundAdjacency,
      adjacency: replaceNullsInAdjacency(foundAdjacency),
    };

    setCurrentAdjacency(processedAdjacency);
  }, [adjacencys, adjacency]);

  // сохраняем в стейт сет для контроля опций
  useEffect(() => {
    const trueValues = currentAdjacency?.adjacency?.map((adj) => adj.railChain).filter(Boolean) || [];
    setExcludedRailChains(new Set(trueValues));
  }, [currentAdjacency]);

  //запрашиваем опции рц для всех станций смежности
  useEffect(() => {
    if (currentAdjacency?.adjacency) {
      currentAdjacency.adjacency.forEach((adj) => {
        if (adj.station) {
          dispatch(initOptionsRailChainsFromServer(adj.station));
        }
      });
    }
  }, [currentAdjacency, dispatch]);

  useEffect(() => {
    // при закрытии компонента чистим стейт загрузки
    return () => {
      dispatch(remove());
    };
  }, [dispatch]);

  return (
    <div className="adjacency">
      <h3 className="modal-title">{`${t?.editAdjacencyTitle || 'РЕДАКТИРОВАНИЕ СМЕЖНОСТИ'} ${
        currentAdjacency?.name
      }`}</h3>
      <h5 className="mb-3">
        {currentAdjacency?.roadName}, {currentAdjacency?.stationName}
      </h5>
      {isLoading && (
        <div className="place-in-middle">
          <Preloader isLoading />
        </div>
      )}
      {!isLoading && isSuccess && (
        <div className="place-in-middle">
          <h5 className="confirmation-title">
            {t?.editAdjacencySuccess || 'Редактирование смежности завершено успешно'}
          </h5>
          <CustomButton
            className="confirmation-btn confirm"
            width="var(--sadr-font-size-420)"
            height="var(--sadr-font-size-60)"
            text={t?.backToList || 'К списку смежности'}
            onClick={closeModal}
          />
        </div>
      )}
      {!isLoading && !isSuccess && (
        <>
          <div className="form-container__forms-all three-column-auto">
            <h3 className="table_header">{t?.station || 'Станция'}</h3>
            <h3 className="table_header">{t?.adjacentRailChain || 'Смежная РЦ'}</h3>
            <h3 className="table_header">{t?.actions || 'Действия'}</h3>
            {currentAdjacency &&
              currentAdjacency?.adjacency?.map((adj, index) => (
                <React.Fragment key={index}>
                  <Selector
                    options={selectOptions?.stations}
                    onChange={(selectedOption) => handleStationChange(selectedOption, index)}
                    placeholder={t?.selectStation || 'Выберите станцию'}
                    value={selectOptions?.stations?.find((option) => option.value === adj.station) || ''}
                    isMulti={false}
                    column="left"
                  />
                  <Selector
                    options={getOptionsAndFilteredOptionsForRC(selectOptions, adj.station, excludedRailChains)}
                    onChange={(selectedOption) => handleRailChainChange(selectedOption, index, adj.railChain)}
                    placeholder={t?.selectRailChain || 'Выберите рельсовую цепь'}
                    value={
                      selectOptions?.railChainsPerStation?.[adj.station]?.find(
                        (option) => option.value === adj.railChain
                      ) || ''
                    }
                    isMulti={false}
                    column="center"
                  />
                  <div className="adjacency__del-button">
                    <CustomButtonDelete
                      column="right"
                      width="fit-content"
                      onClick={() => {
                        removeAdjacencyByIndex(index);
                      }}
                    />
                  </div>
                </React.Fragment>
              ))}
          </div>
          <div className="form-container_submit-button">
            <div className="adjacency-buttons">
              <CustomButton
                className="confirmation-btn align-self-center"
                text={t?.add || '+ Добавить'}
                onClick={handleAdd}
                disabled={!areAllRailChainsFilled}
              />
              <CustomButton
                className="confirmation-btn confirm"
                text={t?.save || 'Сохранить'}
                onClick={handleSave}
                disabled={isDisabled}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default AdjacencyEdit;
